import { ErrorBoundary } from "./components/ErrorBoundary";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { ApplicationsSection, InformationSection } from "./components/Sections";
import { AuthProvider } from "./auth/AuthContext";
import { ForgotPasswordPage, LoginPage, ProfilePage, ResetPasswordPage, SignupPage } from "./auth/AuthPages";

function PortalHome() {
  return <>
    <a className="skip-link" href="#main-content">Skip to main content</a>
    <div id="top" />
    <Header />
    <main id="main-content">
      <Hero />
      <ApplicationsSection />
      <InformationSection />
    </main>
    <Footer />
  </>;
}

function CurrentRoute() {
  switch (window.location.pathname.replace(/\/+$/, "") || "/") {
    case "/login": return <LoginPage />;
    case "/signup": return <SignupPage />;
    case "/profile": return <ProfilePage />;
    case "/forgot-password": return <ForgotPasswordPage />;
    case "/reset-password": return <ResetPasswordPage />;
    default: return <PortalHome />;
  }
}

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider><CurrentRoute /></AuthProvider>
    </ErrorBoundary>
  );
}
